import React, { createContext, useContext, useEffect, useState } from 'react';

const SidebarContext = createContext(null);
const COLLAPSE_KEY = 'trackwithtux_sidebar_collapsed';
const MOBILE_BREAKPOINT = 640; // Tailwind's `sm`

export function SidebarProvider({ children }) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);
  const [collapsedPreference, setCollapsedPreference] = useState(
    () => localStorage.getItem(COLLAPSE_KEY) === 'true'
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Mobile always collapses, regardless of the saved desktop preference —
  // there just isn't room for the expanded rail on a small screen.
  const collapsed = isMobile ? true : collapsedPreference;

  const toggleCollapsed = () => {
    if (isMobile) return;
    setCollapsedPreference((prev) => {
      const next = !prev;
      localStorage.setItem(COLLAPSE_KEY, String(next));
      return next;
    });
  };

  return (
    <SidebarContext.Provider value={{ collapsed, toggleCollapsed, isMobile }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar must be used within a SidebarProvider');
  return ctx;
}
